import { render, staticRenderFns } from "./Kaizen.vue?vue&type=template&id=2ee366fa"
import script from "./Kaizen.vue?vue&type=script&lang=js"
export * from "./Kaizen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports